export default __webpack_public_path__ + "static/media/ARMYToken.1cf13479.jpg";